var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('nav',{staticClass:"tabs-nav-section"},[_c('div',{staticClass:"tabs-nav-wrapper"},[_vm._t("tabs",function(){return [_c('div',{staticClass:"menu-tab"},[_c('am2-tabs',{attrs:{"items":_vm.menuItems,"selected-tab-index":_vm.selectedMenuIndex,"item-style":{
            height: '48px',
          }},on:{"select":_vm.handleMenuSelect}})],1)]}),_vm._v(" "),_vm._t("buttons")],2)])}
var staticRenderFns = []

export { render, staticRenderFns }